/**
 * 公司新闻管理 - 中文（M15）
 */
export default {
  title: '公司新闻',
  readonlyNotice: '当前账号为普通用户，仅可查看新闻。如需编辑，请联系租户管理员。',
  searchPlaceholder: '搜索新闻...',
  add: '添加新闻文章',
  addFirst: '添加第一篇新闻',
  drafts: '草稿箱',
  empty: '暂无新闻内容',
  emptyDraft: '暂无草稿',
  untitled: '未命名新闻',
  noSummary: '暂无摘要内容',
  noDate: '未设置日期',
  confirmDelete: '确认删除这篇新闻吗？',
  editTitle: '编辑新闻文章',
  createTitle: '添加新闻文章',
  previewTitle: '新闻详情',
  draftBoxTitle: '草稿箱',
  form: {
    title: '文章标题',
    titlePlaceholder: '例如：2025年新的可持续发展目标',
    summary: '摘要',
    summaryPlaceholder: '请输入文章摘要（最多500个字符）',
    content: '文章内容',
    contentPlaceholder: '在此输入您的内容...',
    cover: '封面图片（可选）',
    coverUpload: '点击或拖拽上传图片',
    coverHint: '推荐：1200x600px（JPG、PNG，最大 5MB）'
  },
  editor: {
    body: '正文',
    heading: '标题',
    linkPrompt: '请输入链接地址'
  },
  status: {
    draft: '草稿',
    published: '已发布'
  },
  actions: {
    cancel: '取消',
    saveDraft: '保存草稿',
    publish: '发布文章',
    refresh: '刷新',
    edit: '编辑',
    delete: '删除'
  },
  messages: {
    titleRequired: '请输入文章标题',
    contentRequired: '请输入正文内容',
    loadFail: '加载新闻失败',
    saveSuccess: '已保存',
    saveFail: '保存失败',
    publishSuccess: '已发布',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    uploadTooLarge: '图片大小不能超过 5MB',
    uploadFail: '封面上传失败'
  }
}
